import React from 'react';
import './LearningLounge.scss';
import { trackEvent } from '../../utils/gaTracking';
import { useSelector } from 'react-redux';

function QuickLinksCard({ data }) {
      const authState = useSelector((state) => state.authUser);
      const user_id = authState?.profile?.user_id;
      const user_email = authState?.profile?.email;
    
    return (
        <>
            {data[0]?.redirect_url ? <div className='text-center' title={data[0]?.title} onClick={() => { trackEvent(`hrd_quick_link_${data[0].title}_viewed`, `HRD Quick Link ${data[0].title} Viewed`, `HRD Quick Link ${data[0].title} Viewed`, 1, user_id, user_email); window.open(`${data[0]?.redirect_url}`, '_blank', 'noopener') }}>
                <img src={data[0]?.media_url} alt={data[0]?.title} className='quicklinkcardimage' />
            </div>
                :
                <div className='text-center' title={data[0]?.title}>
                    <img src={data[0]?.media_url} alt={data[0]?.title} className='quicklinkcardimage' />
                </div>
            }
        </>
    )
}

export default QuickLinksCard

